
const productsSliders = document.querySelectorAll('.products-slider');

document.addEventListener('DOMContentLoaded', function(){
    let swipers = [];

    function initProductsSliders() {
    if(productsSliders) {
        productsSliders.forEach(function (slider) {
        const container = slider.querySelector(".swiper-container");
    
        if (window.innerWidth < 1025) {
            if (!container.swiper) {
            const swiper = new Swiper(container, {
                slidesPerView: 1.15,
                spaceBetween: 16,
                loop: true,
                observer: true,
                observeParents: true,
                breakpoints: {
                320: {
                    slidesPerView: 1.3,
                    spaceBetween: 16,
                },
                576: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                },
            });
            swipers.push(swiper);
            }
        } else {
            if (container.swiper) {
            container.swiper.destroy(true, true);
            }
        }
        });
    }
    }
    
    window.addEventListener('load', initProductsSliders);
    window.addEventListener('resize', initProductsSliders); 
})